var _defs, _circle, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 319 250",
    style: {
      enableBackground: "new 0 0 319 250"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0F9FF;}\r\n\t.st1{clip-path:url(#SVGID_4_);}\r\n\t.st2{fill:#E58676;}\r\n\t.st3{fill:#FFE3D1;}\r\n\t.st4{fill:#FFA694;}\r\n\t.st5{fill:#4F332E;}\r\n\t.st6{fill:#EFBCA0;}\r\n\t.st7{fill:#1A8476;}\r\n\t.st8{fill:#8C8F99;}\r\n\t.st9{fill:#B4B2C2;}\r\n\t.st10{fill:#AEB2BE;}\r\n\t.st11{fill:#A7D5F7;}\r\n\t.st12{fill:#076D5C;}\r\n\t.st13{fill:#FFFFFF;}\r\n\t.st14{fill:#ED5702;}\r\n\t.st15{fill:#FABF48;}\r\n\t.st16{fill:#E09819;}\r\n\t.st17{fill:#22231E;}\r\n\t.st18{fill:#FBE6D5;}\r\n\t.st19{fill:#E07D6C;}\r\n\t.st20{fill:#C2573C;}\r\n\t.st21{fill:#502B25;}\r\n\t.st22{fill:#512C26;}\r\n\t.st23{fill:#6D9AFF;}\r\n\t.st24{fill:#3B7DF2;}\r\n\t.st25{fill:#C44405;}\r\n"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -28.146543502807617, -0.07927001267671585)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 159.5,
    cy: 130,
    r: 120
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.5,25c-0.2,0-0.3-0.2-0.3-0.3c0-0.4,0.1-4.1,0.2-10.2c0-1.6,1.3-2.9,3-2.9l91.2,0.5 c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3c0,0-91.2-0.5-91.2-0.5c-1.3,0-2.3,1-2.3,2.3c-0.1,3.6-0.2,9.7-0.3,10.3 C110.8,24.8,110.7,25,110.5,25z",
    style: {
      clipPath: "none",
      fill: "rgb(64, 19, 33)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.6,23c1.6-0.4,2.2-1.4,2.3-2.7c0-0.2,0-0.3,0-0.3c0-0.8,0-2.4,0-3.3c0-4,0-8,0-12c0-0.9-0.6-1.6-1.4-1.6 H175c-2.6,0-2.1,2.4-2.1,4.8c0,4.5,0,8.9,0,13.4c0,1.1,0.6,1.5,1.4,1.6c0.8,0.1,1.8,0,2.4,0c2,0,4,0,6,0c7.1,0,25.9,0.2,25.9,0.2 C208.7,23.1,210.2,23.1,210.6,23z",
    style: {
      fill: "rgb(242, 195, 65)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.8,10h-28.2c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h28.2c0.2,0,0.3,0.1,0.3,0.3 C207.1,9.9,206.9,10,206.8,10z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.8,16.3h-28.2c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h28.2c0.2,0,0.3,0.1,0.3,0.3 C207.1,16.2,206.9,16.3,206.8,16.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.5,108.6H65.2c-4.1-0.2-4-5.9-3.9-8.6c0-0.3,0-0.6,0-0.9c0-1.5,0-5.4-0.1-9.8C61.1,82.2,61,74.2,61,71.8 c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3c0,2.4,0.1,10.8,0.1,17.5c0,4.4,0.1,8.3,0.1,9.8c0,0.2,0,0.5,0,0.9 c-0.1,2.7-0.2,7.8,3.3,8l24.3,0c0.2,0,0.3,0.1,0.3,0.3C89.8,108.4,89.7,108.6,89.5,108.6z",
    style: {
      clipPath: "none",
      fill: "rgb(64, 19, 33)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77,65.8c-0.2,0-0.3-0.1-0.3-0.3V32.4c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v33.1 C77.3,65.7,77.2,65.8,77,65.8z",
    style: {
      clipPath: "none",
      fill: "rgb(64, 19, 33)"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 159.5,
    cy: 130,
    r: 120
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 130,
    r: 120,
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4",
    style: {
      clipPath: "url('#SVGID_2_')",
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M227.7,52.3c-1-0.8-2.2-1.4-3.5-1.6c-1.5-0.2-0.4,0.3-0.6-0.8c-0.1-0.5,0.1-1.2,0-1.7 c-0.4-2.6-2.4-4.3-4.9-4.6c-0.3,0-0.5-0.2-0.6-0.5c-2-5.4-9.2-9.1-12.7-4.3c-0.2,0.3-0.7,0.4-1,0.1c-1.7-1.4-3.7-2.4-6-1.5 c-1.5,0.6-2.4,1.9-3,3.3c-0.5,1-0.8,3.3-2.1,3.7c-0.8,0.2-1.6-0.5-2.3-0.7c-3.2-0.9-9.2,1.6-9.8,5.2c-0.2,1.2,0,2.4,0.5,3.4 c0.2,0.3,0.1,0.7-0.2,0.9c-0.6,0.4-1.2,0.9-1.6,1.5c-1.4,1.8-1.7,4-1,6.1c0.1,0.4-0.1,0.8-0.5,0.9c-3.6,0.7-5.9,3.9-4.4,7.9 c1.7,4.5,8.1,6,12.5,6.3c0.2,0,0.4,0.1,0.5,0.3c2.8,4,9.2,0.5,13.3,0.8c4.3,0.3,4.5,4.3,7.6,6.3c2.2,1.4,5.1,1.7,7.6,1.5 c2.4-0.2,4.8-1.1,6.3-3.1c1.7-2.1,0.7-7.1,3.6-7.8c1.8-0.4,4,0.2,4.5-2.1c0.4-1.6-0.1-3.6-0.8-5.5c-0.1-0.3,0-0.6,0.2-0.8 C233.3,62.4,231.4,55.2,227.7,52.3z",
    style: {
      fill: "rgb(94, 35, 30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M228.2,107.2c0.5-0.5-1.8-6.8-2.4-7.1c-2.5-1.3-5.1-3.1-6.8-5.1c-3.1-3.6-2.8-23.7-2.6-30.7 c0-0.2,0-0.4-0.1-0.5c1-0.7,0-2.3-1.1-1.7c-3.1,1.7-5.5,4.1-7.8,6.7c-2.7,3.2-5.5,6.3-8.2,9.5c-0.4,0.4-0.3,1,0,1.3 c0,0.1,0,0.3,0,0.4c0.7,4.8,1.2,9.8,1.4,14.7c0.1,2.8-1,4.5-3.2,6c-0.6,0.4-10.5,4.1-10.6,4.8c-0.5,2.8,5.6,14.1,12.7,14.1 C212.3,119.6,225.5,110,228.2,107.2z",
    style: {
      fill: "rgb(176, 90, 62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M135.7,89.1c-2.8,0.4-8.3,0.7-8.8,4.2c0,0.2,0,0.4,0.1,0.6c0,0.1,0,0.2,0,0.3c1.2,4,7.1,3.6,10.4,3.2 c4.1-0.4,8.4-0.8,10.3-4.7c0,0,0.2-2.1,0.1-2.4c-0.1-0.4-0.6-0.6-0.9-0.8c-1.3-0.6-2.8-0.7-4.1-0.7 C140.3,88.7,137.9,88.8,135.7,89.1z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M184.8,103.6c0,0.1-4.7,1.7-5,1.8c-7.5,3.2-14.7,7.2-21.7,11.4c-7,4.2-14.5,7.5-21.6,11.5 c-3.6,2.1-7.4,4.8-8.4,9c-1.1,4.4-2.8,14.7-0.4,18.5c2.7,4.3,33,0.1,52.7-13.6C182.3,140.9,185,110.9,184.8,103.6z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M142.6,131.4c0.1,1,0.1,2.8,0.9,3.6c1.8,1.8,3.7-5,4-6.1c0.7-2.3,1-4.7,1.4-7c-2.2,1.1-4.5,2.3-6.7,3.4 c0,0.8,0,1.6,0,2.4C142.4,128.9,142.5,130.1,142.6,131.4z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M260,285.3c0.6,0,1-0.5,0.9-1.1c-2.6-24.1-6.3-66.3-15.3-92.9c0,0,0-0.1,0-0.1c0.3-0.2,0.6-0.5,0.5-0.9 c-0.3-4.6-0.9-9.2-1.7-13.7c-0.1-0.6,0-1.2,0.3-1.7c0.2-0.4,0.1-1-0.5-1.2c-19.8-9.3-41.4-3.2-61,3.5c-1.2,0.4-1.9,1.5-2,2.7 c-0.1,4.8,0.2,16.6,0.4,18.8c0,0.3,0,0.6,0,0.9c-7.4,28.5-9.1,62.4-9,62.5c-0.1,1.6-0.1,3.1,0.2,4.7c0.1,0.6,0.7,0.9,1.2,1.2 C195.4,281.7,251.8,286,260,285.3z",
    style: {
      fill: "rgb(81, 34, 32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M217.1,98.6c-0.6-1.6-3.7-1.1-4.8-0.8c-1.3,0.3-2.8,1-4.1,1.4c-1.4,0.5-2.5,1.9-2.5,2.7 c0,0.1,5.2-0.2,7.2-0.6C214.2,101.1,217.9,100.6,217.1,98.6z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M195,197.5c-3,17.6-5.8,35.2-6.9,53c-0.4,7.1-0.7,14.3-0.8,21.4c0,0.4,0.6,0.4,0.6,0 c0.4-20.4,2-40.7,5.4-60.8c0.7-4.5,1.5-9,2.3-13.5C195.7,197.3,195.1,197.1,195,197.5L195,197.5z",
    style: {
      fill: "rgb(51, 19, 19)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M210.2,196.8c0.6,21.6,2.4,43.1,4,64.6c0.4,5.6,0.9,11.2,1.2,16.8c0,0.4,0.7,0.4,0.6,0 c-1.4-20.9-3.4-41.8-4.5-62.7c-0.3-6.2-0.6-12.4-0.8-18.6C210.8,196.4,210.2,196.4,210.2,196.8L210.2,196.8z",
    style: {
      fill: "rgb(51, 19, 19)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229,197.4c5,21.6,10.3,43.1,13.5,65.1c0.9,6.1,1.6,12.3,2,18.4c0,0.4,0.7,0.4,0.6,0 c-1.5-22.2-6.3-44-11.3-65.7c-1.4-6-2.8-12-4.2-18C229.5,196.8,228.9,197,229,197.4L229,197.4z",
    style: {
      clipPath: "none",
      fill: "rgb(64, 19, 33)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.9,56.7c-3.8-13.2-21.5-13.2-29.2-3.4c-2.4,3.1-3.3,7-3.7,10.9c-0.3,3.1-0.6,6.1-0.7,9.2 c-0.2,5,0.1,10.7,5.6,12.7c3,1.1,6.2,0.9,9.4,0.4c3.4-0.6,7-2,8.5-5.3c1.3-3,2.3-6.2,3.1-9.4c0.2-0.8,0.7-1.5,1.4-2 c1.3-0.8,2.5-1.7,3.5-2.8C220.3,64,221,60.3,219.9,56.7z",
    style: {
      fill: "rgb(176, 90, 62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M247.2,120.8c0-0.2,0-0.4-0.1-0.7c-0.9-7.2-3.9-11.3-9.9-15.3c-3.1,2.3-6.3,4.4-9.8,5.7 c-8.2,3.2-20.9,4.9-29.5,3.5c-5.1-0.8-7.3-3.8-10.9-7.3c-1.3,3.1-2.2,6.4-3.3,9.5c-5.6,15.5-7.5,51-5,66.9 c9.9,4.1,29.1,1.1,39.5,1.4c7.1,0.2,16.5,0.9,24.6-4.1c0.8-0.5,1.3-1.3,1.4-2.1c0.2-1.6,0.4-4.3,0.5-5.3 c0.2-2.4,0.5-6.5,0.8-8.9c0.5-5.1,1.1-10.2,1.7-15.3C248.2,140,248,129.6,247.2,120.8z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M221.8,55c-0.8-2.8-2.2-5.5-4.1-7.8c-2-2.5-4.3-3.6-7.5-4c-3.1-0.4-6.3-0.1-9.4,0.5 c-3.6,0.8-7.2,2.1-10.4,3.9c-2.3,1.3-4.3,3.3-4.2,6c0,0.2,0,0.4,0,0.6c0,0,0,0,0,0c0.2,0.8,0.7,1.5,1.9,1.7 c2.1,0.3,4.3-1.1,5.7-2.4c0.5-0.5,0.9-1,1.4-1.5c0.2-0.2,0.4-0.4,0.6-0.5c0.3-0.4,0.9-0.5,1.4-0.4c0.6,0.2,0.8,0.7,1.3,1.2 c0.4,0.4,0.8,0.7,1.3,0.9c2.1,0.9,4.4,0,6.3-1c0.3-0.2,0.7,0,0.9,0.3c0.2,0.4,0.5,0.7,0.9,1c1,0.8,2.1,0.9,3.2,1.2 c1.4,0.4,1.7,1.4,1.6,2.8c-0.1,0.7-0.3,8,1.8,6.9c0,0,3.6-0.5,4.1-0.6c1-0.1,1.9-0.6,2.7-1.3C223.2,60.5,222.5,57.4,221.8,55z",
    style: {
      fill: "rgb(94, 35, 30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M180.7,103.6c-4.8,2-11,6-15.7,9.2c0,0,2.5,12.1,4.2,16.3c0.9,2.4-1.2,4.7-1.3,7.4c0,6.1-0.2,30.5-0.2,36.3 c0,12.3,0.6,29.2,1.6,41.4c0.3,3.9,1.3,9.5,4.2,11.9c2.3,1.9,8.4,4.6,12.5,4.5c1,0,0.2-10.9,0.2-11.9 c-0.4-20.4-1.3-40.7-0.3-61.1c0.9-18.2,1.3-41.6,12.1-57c0.2-0.1,0.4-0.4,0.7-0.8c0.3-0.4-0.1-1-0.6-0.9 C194.8,99.6,188.4,100.4,180.7,103.6z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M262,208.8c1.5-10.1-1.2-21.8-2.2-31.9c-1.7-17.7-4.3-33.6-6.2-51.2c-0.7-6.4-3.1-14-7.6-18.9 c-7.4-8-24-11.7-24.9-10.4c-9.8,13.9-8.1,34.1-8.7,50.4c-0.4,9.3,1.9,68.7,5.6,78.7c0.9,2.4,1.3,3.1,3.5,3.7 c4.3,1.2,8.8,0.3,13.1-0.6C241,227.4,260.8,217.3,262,208.8z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M229.7,167.6c3.3-3.5,6.4-7.3,9.1-11.3c1.4-2.1,2.8-4.2,3.9-6.5c0.8-1.7,1.6-3.8,1.4-5.7 c-0.2-1.9-1.6-2.9-3.4-3.2c-3.4-0.5-7.3,1.8-10.2,3.3c-1.5,0.8-3,1.6-4.5,2.3c-1.9,0.9-3.8,1.6-5.7,2.5c-2.8,1.4-5.4,3-7.9,4.8 c0.1,5.8,0.4,14.3,0.8,23.4C219.5,175.6,225.3,172.4,229.7,167.6z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M213.4,59.2L205.2,82c-0.2,0.6,0.1,1.3,0.8,1.5l14.2,4c0.6,0.2,1.3-0.2,1.4-0.8l6.8-22.4 c0.2-0.6-0.2-1.2-0.8-1.4l-12.8-4.5C214.2,58.3,213.6,58.6,213.4,59.2z",
    style: {
      fill: "rgb(211, 214, 232)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M214.6,59.6c-2.3,7.4-5.1,14.8-7.7,22.1c-0.1,0.4,0.5,0.5,0.6,0.2c2.6-7.4,5.4-14.7,7.7-22.1 C215.3,59.4,214.7,59.2,214.6,59.6L214.6,59.6z",
    style: {
      fill: "rgb(180, 185, 204)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M225.1,73.3c-0.1,0.1-0.2,0.3-0.3,0.3c-0.6,0.7-0.8,0-1.2-1.3c-0.1-0.7-2.1-0.7-2,0c0,0.2,0,0.3,0,0.5 c-0.2,0.1-0.3,0.2-0.3,0.5c0.7,5.7,1.2,11.5,1.4,17.2c0,0.5,0.8,0.4,0.9,0.3c0.8-3,1.6-6.3,2.1-9.5c1-6.4,1.6-10,0.7-10.4 C226.2,70.8,225.4,72.9,225.1,73.3z",
    style: {
      fill: "rgb(176, 90, 62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.3,75.7c-0.1-0.5-0.1-0.9-0.2-1.4c-0.3-1.7-0.8-3.3-1.4-4.9c-0.7-2.1-2-4.2-3.4-5.9 c-0.6-0.7-2.3-2.7-3.4-2.3c-1.4,0.5-1.3,2,0.3,3.6c1.1,1.1,1.8,2.5,2.4,3.9c0.4,0.9,0.7,1.8,0.9,2.8c0.1,0.5,0.2,1,0.2,1.4 c0,0.4-0.1,0.7-0.5,0.2c-1.7-2.1-2.5-3.4-4.2-4.4c-1.2-0.7-2.5-1.2-3.8-1.7c-0.7-0.3-1.8-0.7-2.3,0.1c-0.4,0.6-0.1,1.4,0.3,1.9 c0.5,0.8,2.5,1.1,4,2.4c0.6,0.5,2.4,2.3,2.7,3c0.6,1.2-1.4,0.6-2.1,0.4c-1-0.2-1.8-0.6-2.8-0.8c-1.4-0.3-2.8-0.2-4.2-0.1 c-0.6,0-0.9,0.6-0.8,1.1c0,0.4,0.6,1.3,1,1.4c-0.5-0.1-0.9-0.1-1.3,0.2c-1,0.8-0.2,1.9,0.5,2.6c0.7,0.6,1.5,0.8,2.3,1.2 c0.8,0.3,1.5,0.8,2,1.3c0.3,0.3,0.4,0.8,0.3,1.2c-0.7,4.5-1.8,9.4,0.9,13.6c-0.3,2.7-1.5,9.2-1.6,10.7c0.3,0.1,0.6,0.2,1,0.3 c1.7,0.4,3.5,0.2,5.2-0.3c2.1-0.7,3.2-1.5,5.1-2.7c0.3-3.2,2.5-16.4,2.7-19.6c0.1-2,0.3-4,0.2-6C224.5,78,224.5,76.8,224.3,75.7 z",
    style: {
      fill: "rgb(176, 90, 62)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M207.7,77.4c1.3,0.3,2.7,0.4,3.8,1.1c1.3,0.7,3,2,3.1,3.6c0,0.4,0.7,0.4,0.6,0c-0.2-3.6-4.6-4.5-7.4-5.2 C207.5,76.7,207.3,77.3,207.7,77.4L207.7,77.4z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M208.8,73.7c-0.5-0.3-1-0.3-1.6,0c-0.4,0.2-0.9,0.4-1.1,0.9c-0.4,1,0.6,2.2,1.5,2.7 c0.4,0.2,0.7-0.4,0.3-0.5c-0.5-0.3-1-0.8-1.2-1.4c-0.1-0.4,0.1-0.7,0.4-0.9c0.4-0.2,0.9-0.4,1.3-0.1 C208.8,74.5,209.1,73.9,208.8,73.7L208.8,73.7z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M207.9,76.8c-0.6-0.6-1.8-0.6-2.4,0c-0.8,0.7-0.3,1.8,0.3,2.4c0.3,0.3,0.7-0.1,0.4-0.4 c-0.3-0.4-0.8-1.1-0.3-1.6c0.4-0.3,1.1-0.3,1.5,0C207.7,77.5,208.2,77.1,207.9,76.8L207.9,76.8z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M210.2,66.5c-0.7,0-1.5,0.3-1.7,1.1c-0.2,0.8,0.3,1.7,0.8,2.2c0.3,0.3,0.7-0.2,0.4-0.4 c-0.4-0.4-0.7-0.8-0.7-1.4c0-0.6,0.6-0.8,1.1-0.9C210.6,67.1,210.6,66.5,210.2,66.5L210.2,66.5z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M224,74.4c0.3,0.8,0.6,1.6,1,2.3c0.2,0.4,0.7,0,0.5-0.3c-0.4-0.7-0.7-1.4-1-2.2 C224.5,73.8,223.9,74,224,74.4L224,74.4z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M210.6,85.7c-0.4,2.1-0.7,4.3-0.5,6.4c0.1,0.9,0.2,1.8,0.5,2.6c0.4,1.1,1,2,1.2,3.2 c0.1,0.4,0.7,0.2,0.6-0.2c-0.4-2-1.5-3.6-1.7-5.6c-0.2-2.1,0.1-4.2,0.5-6.2C211.3,85.4,210.7,85.3,210.6,85.7L210.6,85.7z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M195.3,63.9c-1.6,1.2-1.5,3.7,0.4,4.5c0.4,0.2,0.7-0.4,0.3-0.5c-1.4-0.6-1.7-2.5-0.4-3.5 C195.9,64.2,195.6,63.7,195.3,63.9L195.3,63.9z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M196.9,67.3c0.6,0,1.1,0.1,1.5,0.5c0.3,0.3,0.8-0.2,0.4-0.4c-0.6-0.5-1.2-0.7-2-0.7 C196.5,66.7,196.5,67.3,196.9,67.3L196.9,67.3z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M201.5,70.9c-0.5-0.3-1.1-0.3-1.6-0.3c-2.3,0.1-4.6,0-7-0.3c-0.5-0.1-0.6,0.6-0.5,1c0.2,1,0.2,2.2,0.8,3.1 c0.6,0.8,1.6,1.5,2.6,1.5c2.2,0.1,3.9-0.1,5.2-1.6C201.6,73.6,202.8,71.7,201.5,70.9z",
    style: {
      fill: "rgb(74, 21, 17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M143,89.8c0.2-1.4,0.6-2.7,0.6-4.1c0-1.5-0.4-3-1-4.3c-0.6-1.3-4.3-6.3-4.4-6.5c-0.4-1.4-0.7-2.9-0.7-4.4 c-0.1-1.8,0.3-3.6-0.3-5.3c-0.3-0.7-1.3-1-1.8-0.3c-1.1,1.4-1.1,4.8-1.2,6.9c0,0.3-0.4,0.4-0.5,0.1c-0.6-1.4-0.9-3.8-0.6-7 c0.1-0.9,1.4-6.1-0.7-5.7c-2.3,0.5-2.6,3-3.1,5c-0.6,2.6-0.3,5.2-0.4,7.9c-0.5-1.1-1-4.5-0.9-6.4c0.1-2.2,0.4-4.4,0.8-6.5 c0.3-1.3,0.1-4.2-2.1-3.3c-1.9,0.8-2.9,5-3.4,6.8c-0.8,3.1-0.7,6.3,0,9.5c-0.1,0-0.2,0-0.3,0.1c-0.8-2.6-1.1-5.2-0.8-8 c0.2-1.7,1.5-5.3,0.2-6.8c-2.3-2.8-4.1,3.8-4.4,5.2c-0.8,3.6-0.5,7.4,1.3,10.7c1.1,2,2.8,3.7,4.4,5.3c1.2,1.1,2.6,2,3.7,3.2 c1.8,1.9,2.8,4.2,3,6.7c0.2,2.3-1.1,10.7-1.1,10.7c0,0,1.1,0.3,1.1,0.3c3,0.1,12.1-0.1,12.2-0.9c0.2-1.8,0.2-6.7,0.5-8.5 C143,90,143,89.9,143,89.8z",
    style: {
      fill: "rgb(176, 90, 62)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M223.2,97c0-0.3-0.2-0.6-0.5-0.5c-2.5,1.5-8.1,2.1-11.4,2.5c-2,0.3-1.3,0.8-1.5,2.8c0,0-0.3,1,0.4,1 c4.2,0.2,13-2.2,12.9-2.7c0,0,0-0.1,0-0.1C223.2,100.1,223.2,98.1,223.2,97z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.5,72.5c0.8,0.2,1.7,0.2,2.6,0.2c1.7-0.1,3.4-0.3,5-0.9c0-0.3-0.2-0.6-0.6-0.9 c-0.5-0.3-1.1-0.3-1.6-0.3c-2.2,0.1-4.4,0-6.6-0.3C193.2,71.4,193.4,72.2,194.5,72.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M204.9,60.8c-2.2,0-2.3,5.1-0.3,5.2c0.9,0,1.4-1.2,1.5-1.9C206.3,63.2,206.3,60.8,204.9,60.8z",
    style: {
      fill: "rgb(38, 10, 10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M191.2,60.6c-2.1,0-2.1,5.1-0.2,5.2c0.8,0,1.3-1.2,1.4-1.9C192.5,63,192.5,60.7,191.2,60.6z",
    style: {
      fill: "rgb(38, 10, 10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M210.1,57.9c-0.5-2.1-3.8-3.1-5.6-2.8c-1.8,0.3-3.3,2.6-1.4,3.8c0.8,0.5,1.7,0.2,2.6,0.3 c0.7,0,1.5,0.2,2.1,0.5c0.6,0.3,1.1,0.5,1.8,0.1C210.1,59.3,210.2,58.5,210.1,57.9C210.1,57.9,210.1,57.9,210.1,57.9z",
    style: {
      fill: "rgb(94, 35, 30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M242.3,108c-2.3-2.3-6.9-2.7-9.8-0.2c-1.6,1.4-2.5,3.5-3.5,5.3c-1.5,2.6-2.9,5.2-4.3,7.9 c-2.6,5.1-5,10.3-7.2,15.6c-2.4,5.7-5.1,11.7-5.4,18.1c-0.2,6.1-0.6,12.2,5.7,11.7c20.3-1.6,30.2-23.7,31.2-32.6 C250.5,119.5,241,106.7,242.3,108z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.6,57.7c-0.1,0.6,0,1.4,0.4,1.8c0.5,0.4,0.9,0.2,1.4-0.1c0.5-0.3,1.1-0.4,1.7-0.5c0.7,0,1.4,0.3,2-0.3 c1.5-1.2,0.3-3.5-1.1-3.8C191.5,54.5,189,55.6,188.6,57.7C188.6,57.7,188.6,57.7,188.6,57.7z",
    style: {
      fill: "rgb(94, 35, 30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M223.5,98.4c-9.8,2.6-15,2.6-16.6,2.4c-0.5,0-1,0.3-1.1,0.7c-2.9,12.5-5.5,25.2-6.5,38 c-0.7,8.7-2.9,25,9.3,27c8.4,1.4,18.4-2.1,18.3-3C225.9,151,225.2,98,223.5,98.4z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M247.8,136.1c-2.2,8.3-6.8,16.6-13.2,22.4c-6.1,5.4-13.8,7.7-21.8,8c-0.4,0-0.4,0.6,0,0.6 c8-0.3,15.8-2.5,21.9-7.9c6.7-5.8,11.5-14.5,13.7-23C248.6,135.9,248,135.7,247.8,136.1L247.8,136.1z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.9,88.8c0-0.2-0.2-0.4-0.4-0.4c-2,0.2-10.8,1.3-14.7,1.3c-0.5,0-0.9,3.7-0.5,4.2 c2.1,2.3,7.6,0.7,10.2,0.3c1.2-0.2,3.9-0.1,4.8-1.1C145.1,92.4,144.9,90.1,144.9,88.8z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M223.4,98.1c1.1,0.3,1.1,4.6,1.2,5.4c0.3,3.2,0.3,6.5,0.3,9.7c0.1,6.8,0.1,13.5,0.4,20.3 c0.3,6.8,0.6,13.5,0.7,20.3c0,0.4,0.6,0.4,0.6,0c-0.2-10.4-1-20.8-1.1-31.2c0-6.7,0.2-13.4-0.5-20.1c-0.1-1.1-0.1-4.7-1.5-5 C223.2,97.4,223,98,223.4,98.1L223.4,98.1z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M229.2,112.7c-1.6,2.4-3,4.9-4.1,7.5c-0.2,0.4,0.4,0.7,0.5,0.3c1.1-2.6,2.5-5.1,4.1-7.5 C230,112.7,229.4,112.3,229.2,112.7L229.2,112.7z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M206.6,101.7c1.4,0.1,2.8,0,4.2-0.2c0.4-0.1,0.2-0.7-0.2-0.6c-1.3,0.3-2.6,0.3-4,0.2 C206.2,101,206.2,101.6,206.6,101.7L206.6,101.7z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M186.4,196.7c4.3,1.1,8.9,1,13.3,1c4.4,0,8.9,0,13.1-1c0.4-0.1,0.2-0.7-0.2-0.6c-4.2,1-8.7,0.9-13,0.9 c-4.3,0-9,0.2-13.2-0.9C186.2,196,186,196.6,186.4,196.7L186.4,196.7z",
    style: {
      fill: "rgb(51, 19, 19)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M167.1,130.8c-0.2,5.7-0.1,11.4,0.2,17.1c0,0.4,0.7,0.4,0.6,0c-0.3-5.7-0.4-11.4-0.2-17.1 C167.7,130.4,167.1,130.4,167.1,130.8L167.1,130.8z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M188.5,55.2c-3.9-1.5-1.9-6.3,1.2-7.3c1.5-0.5,2.8-0.3,4.3-0.1c0.6,0.1,1,0.2,1.5-0.1 c0.8-0.5,1.2-1.6,2-2.2c1.1-0.9,2.3-1.6,3.6-2c2.7-1,6.4-1.7,7.7,1.6c0.2,0.4,0.8,0.2,0.6-0.2c-1.2-2.9-3.9-3.3-6.6-2.6 c-1.6,0.4-3.2,1-4.6,1.8c-0.7,0.4-1.3,1-1.9,1.6c-0.8,0.8-1,1.6-2.4,1.5c-1.6-0.1-3-0.4-4.7,0.3c-1.2,0.5-2.3,1.3-3,2.5 c-1.2,2.2-0.4,5,2.1,6C188.7,55.9,188.9,55.3,188.5,55.2L188.5,55.2z",
    style: {
      fill: "rgb(56, 18, 15)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M180.3,58.7c-0.9,2-1.5,4.3,0.8,5.7c2.1,1.2,4.4,0.1,6-1.3c0.3-0.3-0.1-0.7-0.4-0.4 c-1.2,1.1-2.9,2-4.6,1.5c-2.5-0.8-2-3.2-1.2-5.1C181,58.6,180.5,58.3,180.3,58.7L180.3,58.7z",
    style: {
      fill: "rgb(56, 18, 15)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M215.4,45.3c-2.3,0.3-4,2.3-4.5,4.5c-0.6,2,0.2,5.2,2.7,5.6c0.7,0.1,2.4-0.7,2.7-0.4 c0.2,0.2,0.1,1.4,0.2,1.7c0.2,0.6,0.4,1.1,0.8,1.5c1.3,1.6,3.6,1.7,5.2,0.4c0.3-0.3-0.1-0.7-0.4-0.4c-1.4,1.2-3.5,0.8-4.5-0.7 c-0.4-0.6-0.6-1.3-0.6-2c0-0.8,0.2-0.7,0-1.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.9,0-1.5,0.7-2.4,0.7c-1.8,0.1-2.8-1.9-2.8-3.5 c-0.1-2.3,1.8-5.1,4.1-5.4C215.8,45.9,215.8,45.3,215.4,45.3L215.4,45.3z",
    style: {
      fill: "rgb(56, 18, 15)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M147.7,91.1c0-0.6-0.6-1.1-1.2-0.8c-5.6,2.5-12.4,2.1-18.6,1.9c-0.5,0-0.9,0.3-1,0.7 c-0.6,2.4-2.6,9.9-3.3,12.3c-2,6.9-3.9,13.8-5,20.9c-0.3,1.8-0.5,3.7-0.7,5.6c-0.8,9.5-0.7,21,9.6,25.1 c4.5,1.8,16.5,0.2,21.5-1.8c6.5-2.6-5-15.6-4.5-24.5C144.7,126.6,147.2,97.8,147.7,91.1z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M200.6,86.7c2.1-0.2,4.2-0.8,6.1-1.8c0.4-0.2,0-0.7-0.3-0.5c-1.8,0.9-3.7,1.5-5.7,1.7 C200.2,86.2,200.2,86.8,200.6,86.7L200.6,86.7z",
    style: {
      fill: "rgb(97, 31, 25)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M144.9,91.4c0.4-0.1,0.8-0.1,1.2-0.3c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.2,0-0.8-0.3-0.5 c-0.3,0.2-0.5,0.4-0.7,0.5c-0.3,0.2-0.6,0.3-1,0.3C144.5,90.8,144.5,91.4,144.9,91.4L144.9,91.4z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M228.7,176.1c5.2,6,11.3,11,18.1,15c0.4,0.2,0.7-0.3,0.3-0.5c-6.8-3.9-12.9-8.9-18-14.9 C228.9,175.4,228.5,175.8,228.7,176.1L228.7,176.1z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M176,179c-2.3,4.9-4,10-5,15.3c-0.1,0.4,0.5,0.6,0.6,0.2c1-5.3,2.6-10.3,4.9-15.2 C176.7,178.9,176.2,178.6,176,179L176,179z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M199.9,98.2c0.2-0.4,0.8-2.1,0.1-2c-3.5,0.6-11.2,5.7-12.9,7.4c-1.1,1.1-1.4,3.3-1.7,4.7 c-1.9,9.6-1.6,19.5,0.4,29.2c0.1,0.6,0.2,1.2,0.4,1.7c0,0.1,0.5,0.9,0.5,0.9c0.2-3.1,2-14,4.1-21 C195.4,104.2,199.6,98.9,199.9,98.2z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M186.5,139.9c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.2-0.5-1.5-0.7-2.2c-2-10.1-2.2-19.8-0.4-28.9l0.1-0.5 c0.3-1.4,0.6-3.3,1.7-4.3c1.4-1.4,2.9-2.6,4.2-3.4c0.1-0.1,0.3,0,0.4,0.1c0.1,0.1,0.1,0.3-0.1,0.4c-1.3,0.8-2.7,2-4.1,3.4 c-0.9,0.9-1.2,2.7-1.5,4l-0.1,0.5c-1.8,9-1.7,18.6,0.4,28.6c0.1,0.5,0.4,1.4,0.7,2.1c0.1,0.2,0,0.3-0.2,0.4 C186.6,139.9,186.5,139.9,186.5,139.9z",
    style: {
      fill: "rgb(78, 140, 249)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.6,46.3c0-1-1-1.9-2.2-1.9C94.1,44.3,76.9,44,74.2,44c-12.4,0-24.9,0.2-37.2,0.2c-4.3,0-3.2,0.6-2.9,13.6 c0.1,3.3,0.2,16.7,0.2,21.7c0,1.1,0.8,2.1,1.8,2.2c5.8,0.6,21.2,0.2,31.7,0.2c10.4,0,20.9,0.1,31.3,0c0.4,0,0.8,0,1.2,0 c1.3,0,2.4-0.9,2.4-2C102.5,69,102.5,57.3,102.6,46.3z",
    style: {
      fill: "rgb(242, 195, 65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M91,18.2c0-0.6-0.4-1.1-0.9-1.1c-2.5-0.1-9.6-0.2-10.7-0.2c-5,0-10.1,0.1-15.2,0.1c-1.8,0-1.3,0.4-1.2,7.7 c0,1.8,0.1,9.4,0.1,12.2c0,0.6,0.3,1.2,0.7,1.3c2.4,0.3,8.6,0.1,12.9,0.1c4.3,0,8.5,0,12.8,0c0.2,0,0.3,0,0.5,0c0.5,0,1-0.5,1-1.1 C90.9,31,90.9,24.4,91,18.2z",
    style: {
      fill: "rgb(7, 141, 134)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M123.2,18.2c0-0.6-0.4-1.1-0.9-1.1c-2.5-0.1-9.6-0.2-10.7-0.2c-5,0-10.1,0.1-15.2,0.1 c-1.8,0-1.3,0.4-1.2,7.7c0,1.8,0.1,9.4,0.1,12.2c0,0.6,0.3,1.2,0.7,1.3c2.4,0.3,8.6,0.1,12.9,0.1c4.3,0,8.5,0,12.8,0 c0.2,0,0.3,0,0.5,0c0.5,0,1-0.5,1-1.1C123.1,31,123.1,24.4,123.2,18.2z",
    style: {
      fill: "rgb(237, 88, 6)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104.3,30c2.6,1.4,4.4-1.2,6.1-2.8c0.6-0.6,2-1.5,2.2-2.3c0.1-0.6-0.3-0.6-0.5-1c-0.3-0.8,0.4-1.5,1.1-1.9 c0.8-0.5,1.2-0.2,1.8,0.4c0.6,0.6,1.2,1.2,1.2,2.2c-0.1,1.2-1.3,2.1-2.1,2.9c-0.8,0.8-1.7,1.5-2.6,2.2c-1.6,1.3-3.3,2.8-5.1,3.8 c-1.2,0.7-3.2,0.2-3.9-1.2c-0.2-0.6-0.1-0.6,0.3-1.1C103,30.7,103.7,29.9,104.3,30c0.5,0.1,0.6-0.5,0.2-0.6 c-0.6-0.1-0.9,0-1.3,0.3c-0.4,0.3-1.5,1.2-1.6,1.7c-0.2,0.9,1.2,2,1.8,2.5c1.5,1,2.7,0.4,4.1-0.5c1.8-1.3,3.6-2.6,5.3-4.1 c2.3-1.9,5.7-4.3,3-7.2c-0.6-0.6-1.2-1.5-2.1-1.2c-0.8,0.3-2,1.3-2.2,2.2c-0.1,0.4-0.1,0.5,0,0.8c0,0.1,0.3,0.2,0.3,0.3 c0.1,0.4,0,0.7-0.2,1c-0.2,0.3-0.7,0.7-1,0.9c-1.5,1.4-3.8,4.5-5.9,3.3C104.2,29.3,103.9,29.8,104.3,30z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M 86.1 33.9 C 86 33.9 85.89999999999999 33.9 85.8 33.9 C 85.8 33.9 85.7 33.9 85.7 33.9 L 82.60000000000001 33.9 C 77.50000000000001 33.9 72.50000000000001 33.9 67.4 33.9 C 67.2 33.9 67.10000000000001 33.8 66.9 33.699999999999996 C 66.60000000000001 33.4 66.60000000000001 32.8 66.60000000000001 32.3 C 66.60000000000001 32.199999999999996 66.60000000000001 32.099999999999994 66.60000000000001 31.999999999999996 C 66.60000000000001 31.899999999999995 66.60000000000001 22.499999999999996 66.7 22.099999999999994 C 66.8 21.599999999999994 67 21.499999999999993 67.2 21.499999999999993 L 86 21.499999999999993 C 86.3 21.499999999999993 86.6 21.799999999999994 86.6 22.199999999999992 L 86.6 23.499999999999993 C 86.6 25.799999999999994 86.6 28.299999999999994 86.6 30.499999999999993 C 86.6 31.499999999999993 86.6 32.49999999999999 86.6 33.49999999999999 C 86.6 33.599999999999994 86.6 33.699999999999996 86.5 33.79999999999999 C 86.4 33.9 86.3 33.9 86.1 33.9 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M 85.7 33.2 C 85.7 33.2 85.8 33.2 85.9 33.2 C 85.9 33.2 86 33.2 86.10000000000001 33.2 C 86.10000000000001 32.2 86.10000000000001 31.300000000000004 86.10000000000001 30.300000000000004 C 86.10000000000001 28.100000000000005 86.10000000000001 25.600000000000005 86.10000000000001 23.300000000000004 L 86.10000000000001 22.000000000000004 C 86.10000000000001 22.000000000000004 86.10000000000001 21.900000000000002 86.10000000000001 21.900000000000002 L 81.50000000000001 21.900000000000002 L 67.40000000000002 21.900000000000002 C 67.40000000000002 21.900000000000002 67.40000000000002 22.000000000000004 67.40000000000002 22.000000000000004 C 67.40000000000002 22.300000000000004 67.40000000000002 28.6 67.40000000000002 31.800000000000004 C 67.40000000000002 31.900000000000006 67.40000000000002 32.00000000000001 67.40000000000002 32.1 C 67.40000000000002 32.300000000000004 67.40000000000002 33 67.50000000000001 33.1 C 72.60000000000001 33.1 77.60000000000001 33.1 82.70000000000002 33.1 L 85.7 33.2 C 85.7 33.2 85.7 33.2 85.7 33.2 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.8,27.3c-0.2,0-0.3,0-0.5-0.1l-9.2-4.8C67,22.4,67,22.2,67,22c0.1-0.2,0.3-0.2,0.4-0.1l9.2,4.8 c0.1,0.1,0.3,0.1,0.4,0l9.2-4.9c0.2-0.1,0.3,0,0.4,0.1c0.1,0.2,0,0.3-0.1,0.4l-9.2,4.9C77.2,27.3,77,27.3,76.8,27.3z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.8,62.9c-3.8,0-6.7,0.1-10.6,0.1c-1.3,0-4.9,0.3-5.9-0.5c-0.9-0.6-0.7-2-0.7-2.8c0-3,0-6,0-9 c0-0.9,0.8-1.6,1.8-1.6c5.1,0,10.3,0,15.4,0c1,0,1.8,0.7,1.8,1.6c0,3.5,0,7.1,0,10.6C57.6,62.2,56.8,62.9,55.8,62.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.9,62.9c-3.8,0-6.7,0.1-10.6,0.1c-1.3,0-4.9,0.3-5.9-0.5c-0.9-0.6-0.7-2-0.7-2.8c0-3,0-6,0-9 c0-0.9,0.8-1.6,1.8-1.6c5.1,0,10.3,0,15.4,0c1,0,1.8,0.7,1.8,1.6c0,3.5,0,7.1,0,10.6C77.7,62.2,76.9,62.9,75.9,62.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.9,62.9c-3.8,0-6.7,0.1-10.6,0.1c-1.3,0-4.9,0.3-5.9-0.5c-0.9-0.6-0.7-2-0.7-2.8c0-3,0-6,0-9 c0-0.9,0.8-1.6,1.8-1.6c5.1,0,10.3,0,15.4,0c1,0,1.8,0.7,1.8,1.6c0,3.5,0,7.1,0,10.6C97.8,62.2,97,62.9,95.9,62.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.8,74.4c-3.8,0-6.7,0.1-10.6,0.1c-1.3,0-4.9,0.2-5.9-0.3c-0.9-0.4-0.7-1.4-0.7-2c0-2.1,0-4.2,0-6.3 c0-0.6,0.8-1.1,1.8-1.1c5.1,0,10.3,0,15.4,0c1,0,1.8,0.5,1.8,1.1c0,2.4,0,4.9,0,7.3C57.6,73.9,56.8,74.4,55.8,74.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.9,74.4c-3.8,0-6.7,0.1-10.6,0.1c-1.3,0-4.9,0.2-5.9-0.3c-0.9-0.4-0.7-1.4-0.7-2c0-2.1,0-4.2,0-6.3 c0-0.6,0.8-1.1,1.8-1.1c5.1,0,10.3,0,15.4,0c1,0,1.8,0.5,1.8,1.1c0,2.4,0,4.9,0,7.3C77.7,73.9,76.9,74.4,75.9,74.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.9,74.4c-3.8,0-6.7,0.1-10.6,0.1c-1.3,0-4.9,0.2-5.9-0.3c-0.9-0.4-0.7-1.4-0.7-2c0-2.1,0-4.2,0-6.3 c0-0.6,0.8-1.1,1.8-1.1c5.1,0,10.3,0,15.4,0c1,0,1.8,0.5,1.8,1.1c0,2.4,0,4.9,0,7.3C97.8,73.9,97,74.4,95.9,74.4z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.6,52.3c1.7,0,3.5,0,5.2,0c0.4,0,0.4-0.6,0-0.6c-1.7,0-3.5,0-5.2,0C41.1,51.6,41.1,52.3,41.6,52.3 L41.6,52.3z",
    style: {
      fill: "rgb(242, 195, 65)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.1,52.3c1.7,0,3.5,0,5.2,0c0.4,0,0.4-0.6,0-0.6c-1.7,0-3.5,0-5.2,0C60.7,51.6,60.7,52.3,61.1,52.3 L61.1,52.3z",
    style: {
      fill: "rgb(242, 195, 65)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.6,52.6c1.7,0,3.5,0,5.2,0c0.4,0,0.4-0.6,0-0.6c-1.7,0-3.5,0-5.2,0C81.2,51.9,81.2,52.6,81.6,52.6 L81.6,52.6z",
    style: {
      fill: "rgb(242, 195, 65)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M279.1,53.7h-37.9c-0.8,0-1.4,0.7-1.4,1.6c0,4,0,8,0,12c0,0.9,0,3.7,0,4.5c0,0.1,0,0.3-0.1,0.4 c-0.3,0.9-1.3,2.9-1.7,3.9c0,0.1,0,0.2,0.1,0.2c0.5-0.1,5.8-2.6,6-2.7c0,0,18.9-0.2,25.9-0.2c2,0,4,0,6,0c0.6,0,1.6,0.1,2.4,0 c0.8-0.1,1.4-0.5,1.4-1.6c0-4.5,0-8.9,0-13.4C279.9,57.5,280.5,53.7,279.1,53.7z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M274.6,60.5h-28.2c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h28.2c0.2,0,0.3,0.1,0.3,0.3 C274.9,60.4,274.7,60.5,274.6,60.5z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M274.6,66.9h-28.2c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h28.2c0.2,0,0.3,0.1,0.3,0.3 S274.7,66.9,274.6,66.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.1,101.4c0-0.4-0.5-0.8-1-0.8c-2.9,0-10.8-0.1-12.1-0.1c-5.7,0-11.4,0.1-17.1,0.1c-2,0-1.5,0.3-1.4,5.9 c0,1.4,0.1,7.2,0.1,9.3c0,0.5,0.4,0.9,0.8,1c2.7,0.3,9.8,0.1,14.6,0.1c4.8,0,9.6,0,14.4,0c0.2,0,0.4,0,0.5,0 c0.6,0,1.1-0.4,1.1-0.9C109.1,111.1,109.1,106.1,109.1,101.4z",
    style: {
      fill: "rgb(109, 154, 255)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.4,108.7H82.7c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h20.6c0.2,0,0.3,0.1,0.3,0.3 C103.7,108.5,103.6,108.7,103.4,108.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.5809e984a817987d998a5a67c0fec655.svg";
export { ForwardRef as ReactComponent };